var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "delete-task-wrapper" },
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "button",
              {
                on: {
                  click: _vm.onRemove,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("DeleteIcon", { staticClass: "w-4 h-4" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("DeleteIcon", { staticClass: "w-4 h-4" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        { showModal: _vm.showModal }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }